module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Green-Guy-Web-640.34638555.jpg";